export const api570SelectOptions = {
    api570Score: [
        { value: '1', name: 'good', translateText: 'condition.good' },
        { value: '3', name: 'reasonable', translateText: 'condition.reasonable' },
        { value: '5', name: 'poor', translateText: 'condition.poor' },
        { value: '6', name: 'bad', translateText: 'condition.critical' },
        { value: 'U', name: 'unknown', translateText: 'condition.unknown' },
        { value: 'F', name: 'further', translateText: 'condition.further' },
    ],
};
